<div class="flex justify-between items-center flex-wrap">
  <div *ngIf="showTitle" class="text-xl font-semibold mb-4">{{tableTitle}}</div>
  <div></div>
  <div class="flex items-center gap-2">
    <button *ngIf="showFilter" (click)="onFilter()" class="custom-button custom-button-info">
      <i class="fal fa-filter"></i>
    </button>
    <button *ngIf="showBulkPrint" (click)="onBulkPrint()" class="custom-button custom-button-success-filled"
      matTooltip="Print current page">
      <i class="fal fa-print"></i>
    </button>
    <button *ngIf="showBulkDelete" (click)="onBulkDelete()" class="custom-button custom-button-primary">
      <i class="fal fa-trash"></i>
    </button>
  </div>
</div>

<div class="grid grid-cols-12 gap-x-4">
  <div [class]="limitClassName||defaultClassNameHeaderForm">
    <div class="mb-4">
      <div *ngIf="showFormHeaderLabel" class="text-sm">Limit</div>
      <mat-select (selectionChange)="pagination.input.setLimitMat($event)" [value]="pagination.limit" class="form-control">
        <mat-option [value]="5">5 entries</mat-option>
        <mat-option [value]="10">10 entries</mat-option>
        <mat-option [value]="20">20 entries</mat-option>
        <mat-option [value]="50">50 entries</mat-option>
        <mat-option [value]="100">100 entries</mat-option>
        <mat-option [value]="500">500 entries</mat-option>
        <mat-option [value]="1000">1000 entries</mat-option>
      </mat-select>
    </div>
  </div>
  <div *ngIf="haveSpaceBetweenLimitAndSearch" [class]="spaceBetweenLimitAndSearchClassName||defaultClassNameHeaderForm">
    <!-- optional extra filter of the screen: <div tableMiddleFilter class="mb-4"> ... </div> -->
    <ng-content select="[tableMiddleFilter]"></ng-content>
  </div>
  <div [class]="searchClassName||defaultClassNameHeaderForm">
    <div class="mb-4">
      <div *ngIf="showFormHeaderLabel" class="text-sm">Search</div>
      <div class="form-control-group">
        <div class="form-control-group-label">
          <i class="fal fa-search"></i>
        </div>
        <input (input)="pagination.input.setSearch($event)" type="text" placeholder="Search"
          class="form-control-group-input">
      </div>
    </div>
  </div>
</div>

<div class="relative overflow-x-auto mb-4" #tableContainer>
  <ng-content></ng-content>
</div>

<div class="flex justify-between flex-wrap gap-2">
  <div class="mb-4">
    <nav>
      <ul class="inline-flex flex-wrap text-base">
        <li>
          <button [disabled]="pagination.hasPrev" (click)="pagination.goToPage(1)" type="button" class="custom-button">
            <i class="fal fa-chevron-double-left"></i>
          </button>
        </li>
        <li>
          <button [disabled]="pagination.hasPrev" (click)="pagination.goToPage(pagination.currentPage - 1)"
            type="button" class="custom-button">
            <i class="fal fa-chevron-left"></i>
          </button>
        </li>
        <li *ngFor="let p of Helper.array.makeArrayOfNumber(
            pagination.currentPage > 3 ? pagination.currentPage-3 : 0, 
            pagination.currentPage < ((pagination.totalPage+1)-3) ? pagination.currentPage+2 : pagination.totalPage
          )">
          <button (click)="pagination.goToPage(p)" type="button"
            class="{{pagination.currentPage==p?'custom-button-primary-filled':''}} custom-button">
            {{p}}
          </button>
        </li>
        <li>
          <button [disabled]="pagination.hasNext" (click)="pagination.goToPage(pagination.currentPage + 1)"
            type="button" class="custom-button">
            <i class="fal fa-chevron-right"></i>
          </button>
        </li>
        <li>
          <button [disabled]="pagination.hasNext" (click)="pagination.goToPage(pagination.totalPage)" type="button"
            class="custom-button">
            <i class="fal fa-chevron-double-right"></i>
          </button>
        </li>
      </ul>
    </nav>
  </div>
  <div class="mb-4 grow-[1]"></div>
  <div class="mb-4 grow-[1] text-end">
    Showing entries {{pagination.start+1}} to {{pagination.end}} of {{pagination.totalCount}}
  </div>
</div>